export function saveSession(id, sessionData) {
  localStorage["PocketSecureNew-" + id] = JSON.stringify({...sessionData, id});
}

export function readSession(id) {
  return JSON.parse(localStorage[`PocketSecureNew-${id}`]);
}

export function readSessions() {
  const sessions = [];
  for (const key of Object.keys(localStorage).filter((x) =>
    x.match(/^PocketSecureNew-/)
  )) {
    sessions.push({
      ...JSON.parse(localStorage[key]),
      id: key.split("-")[1],
    });
  }
  return sessions;
}

export function removeSession(id) {
  delete localStorage[`PocketSecureNew-${id}`];
}
